import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import animation from "../../../../Animation/Start a Project.json";

import { ScrollTrigger } from "gsap/all";
import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import { Link } from "react-router-dom";
import { Menu } from "../../../../Context/MenuOpen/MenuContext";
const EventMangeTab = () => {
  const {t , i18n} = useTranslation()
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  gsap.registerPlugin(ScrollTrigger);
  useGSAP(() => {
  
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });
  return (
    <div className="WebDevelopment">
      <div className="svg">
        <div className="flex flex-col items-start">
          <h4>{t("BESPOKE SOLUTION")}</h4>
          <h5>{t("Event management")}</h5>
          <div ref={lottieContainerRef} className="w-[80vw] md:w-[35vw] mt-[5vh]">
          {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
          </div>
        </div>
      </div>
      <div className="content">
        <p>
        {t("We manage the full experience from pre-event setup to the final live stream with technical precision and creative vision. Whether it's a high-profile on-ground launch, a hybrid experience, or a fully virtual production, we plan, shoot, edit, and publish everything live and in sync. Our team runs the background so you can stay focused up front.")}



        </p>
        <ul>
          <li>
          {t("We manage offline and virtual events from logistics and coordination to full technical execution.")}
          </li>
          <li>
          {t("We deliver multi-camera live streaming with smooth switching and stable, high-quality output.")}
          </li>
          <li>
          {t("Real-time video editing and instant publishing ensure you reach your audience without delay.")}
          </li>
          <li>
          {t("We provide full AV setup: lighting, sound, staging, and on-site direction.")}
          </li>
          <li>
          {t("We support studio-based live broadcasting with real-time feed control and switching.")}
          </li>
          <li>
          {t("After the event, we deliver polished media kits that help your content live far beyond the event day.")}
          </li>
        </ul>
        <Link className="btn-hover" to="/event-management">
          <span>{t("Event Management")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="m14.331 7l3.5 5l-3.5 5h-3.052l3.5-5l-3.5-5z"
                clip-rule="evenodd"
              />
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="m8.331 7l3.5 5l-3.5 5H5.279l3.5-5l-3.5-5z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default EventMangeTab;
